import React from 'react';
import SEO from './SEO';
import './LegalPages.css';

function PrivacyPolicy() {
  return (
    <main id="main-content" className="legal-page">
      <SEO
        title="Privacy Policy | UBOTIKA"
        description="UBOTIKA's privacy policy: what we collect, how we use it, and our commitment to never share or sell your personal information, including phone numbers."
        path="/privacy"
      />
      <div className="legal-content">
        <h1>Privacy Policy</h1>
        <p className="last-updated">Last Updated: July 10, 2026</p>

        <section>
          <h2>1. Information We Collect</h2>
          <p>
            When you use our contact form, free audit form, or communicate with us by phone or
            text message, we collect the following information:
          </p>
          <ul>
            <li>Name (optional)</li>
            <li>Email address (required)</li>
            <li>Phone number (optional)</li>
            <li>Company name and website (optional)</li>
          </ul>
        </section>

        <section>
          <h2>2. We Do Not Sell or Share Your Personal Information</h2>
          <p>
            UBOTIKA does not share, sell, rent, or trade consumer personal information —
            including phone numbers — with third parties or affiliates for their marketing,
            promotional, or lead-generation purposes.
          </p>
          <p>
            No mobile information will be shared with third parties or affiliates for marketing
            or promotional purposes. Text-messaging originator opt-in data and consent will not
            be shared with any third parties, excluding the messaging providers used strictly to
            deliver messages to you.
          </p>
        </section>

        <section>
          <h2>3. How We Use Your Information</h2>
          <p>
            We use the information you provide to:
          </p>
          <ul>
            <li>Respond to your inquiries</li>
            <li>Provide information about our services</li>
            <li>Communicate with you about your project</li>
            <li>Improve our services and website</li>
          </ul>
        </section>

        <section>
          <h2>4. Cookies</h2>
          <p>
            We use cookies to enhance your browsing experience. You can control cookie preferences
            through our cookie consent banner. We use:
          </p>
          <ul>
            <li><strong>Necessary cookies:</strong> Essential for website functionality</li>
            <li><strong>Analytics cookies:</strong> Help us understand how visitors interact with our website</li>
            <li><strong>Marketing cookies:</strong> Used to deliver personalized advertisements</li>
          </ul>
        </section>

        <section>
          <h2>5. Data Storage and Security</h2>
          <p>
            Your information is stored securely and is only accessible by authorized personnel.
            We implement appropriate technical and organizational measures to protect your data.
          </p>
        </section>

        <section>
          <h2>6. Third-Party Service Providers</h2>
          <p>
            We use a small number of service providers to operate our website and services:
          </p>
          <ul>
            <li>Cloud storage providers for media hosting</li>
            <li>Webhook services for form submissions</li>
            <li>AI services for conversational features</li>
            <li>Analytics and advertising measurement (Google Analytics, Google Ads)</li>
          </ul>
          <p>
            These providers process data solely on our behalf to deliver our services. They are
            not permitted to use your personal information for their own marketing or
            lead-generation purposes.
          </p>
        </section>

        <section>
          <h2>7. Your Rights</h2>
          <p>
            You have the right to:
          </p>
          <ul>
            <li>Access your personal data</li>
            <li>Request correction of your data</li>
            <li>Request deletion of your data</li>
            <li>Opt-out of marketing communications</li>
            <li>Withdraw consent at any time</li>
          </ul>
        </section>

        <section>
          <h2>8. Children's Privacy</h2>
          <p>
            Our services are not directed to children under 13 years of age. We do not knowingly
            collect personal information from children under 13.
          </p>
        </section>

        <section>
          <h2>9. Changes to This Policy</h2>
          <p>
            We may update this Privacy Policy from time to time. We will notify you of any changes
            by posting the new Privacy Policy on this page and updating the "Last Updated" date.
          </p>
        </section>

        <section>
          <h2>10. Contact Us</h2>
          <p>
            If you have any questions about this Privacy Policy, please contact us through our
            contact form or email us at: <a href="mailto:privacy@ubotika.com">privacy@ubotika.com</a>
          </p>
        </section>

        <div className="legal-back-link">
          <a href="/">← Back to Home</a>
        </div>
      </div>
    </main>
  );
}

export default PrivacyPolicy;
